/**
 * Created by 唐亦慧 on 2018/2/6.
 */
import React from 'react';
import Reflux from 'reflux';
import { hashHistory } from 'react-router';
import {
  Layout,
  Badge,
  Menu,
  Input,
  message,
} from 'antd';
import '../mall-menus.css';
import '../mallApp.css';
import { getProductCategory } from '../../service/product';
import { getShoppingCarList } from '../../service/shoppingCar';
import {
  productActions,
  productStore,
} from '../mallHome/store';
import { getOrderList, getOrderList2 } from '../../service/order';
import { openNotice } from '../../utils';

const { Header, Content } = Layout;

class MallCommon extends Reflux.Component {
  constructor(props) {
    super(props);
    this.store = Reflux.initStore(productStore);
    this.userData = JSON.parse(window.localStorage.getItem('login_user_information') || '{}');
    this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
    this.state = {
      maxKey: [this.props.location.query.key] || [],
      mainMenu: [],
      minMenu: [],
      mainHeight: window.document.body.clientHeight - 64 - 128 - 132 + 'px',
      showFlag: false, //一级菜单是否显示
      secondFlag: false, //二级菜单是否显示
      cartCount: 0, //购物车
      orderLength: 0, //订单
      orderSearchObj: {
        code: '',
        productCode: '',
        orderStatus: '',
        orderType: '',
        gatherRealityAddress: '',
        channelCode: this.channelData.split('|')[1] || '',
        getProCode: '',
        customerOrderCode: '',
        startCreatedDate: '',
        endCreatedDate: '',
        buyCompanyId: '',
        remark: '',
        specialOfferCode: '',
        s: 10,
        p: 1,
      },
      keyword: this.store.state.searchMallData.name, //关键字
    };
    this.mouseEnter = this.mouseEnter.bind(this);
    this.getMinKey = this.getMinKey.bind(this);
    this.mouseLeave = this.mouseLeave.bind(this);
    this.menuShow = this.menuShow.bind(this);
    this.goList = this.goList.bind(this);
    this.goView = this.goView.bind(this);
    this.resize = this.resize.bind(this);
    this.getMainMenu = this.getMainMenu.bind(this);
    this.getCartCount = this.getCartCount.bind(this);
  }

  componentDidMount() {
    window.onresize = this.resize;
    document.addEventListener('changeCart', this.getCartCount, false);
    this.getMainMenu();
    this.getCartCount();
    if(this.userData.second) {
      // trans/order/list
      getOrderList2({p: 1, s: 10}).then(result => {
        if (result && result.code == 200) {
          this.setState({
            'orderLength': result.total,
          });
        } else {
          openNotice('error', '数据获取失败', '');
        }
      })
    } else {
      getOrderList(this.state.orderSearchObj).then((result) => {
        if (result && result.code == 200) {
          this.setState({
            'orderLength': result.total,
          });
        } else {
          openNotice('error', '数据获取失败', '');
        }
      });
    }
  }

  //获取菜单
  getMainMenu() {
    getProductCategory().then((result) => {
      if (result.status) {
        const filterEmpty = (list, codePath) => list.map(x => {
          let key = x.code; // 实际使用的业务数据是 code；
          if (x.children && x.children.length) {
            return {
              ...x,
              key: key, // 使用实际业务数据重新给 key 赋值
              value: key, // 使用实际业务数据重新给 value 赋值
              isLeaf: false,
              disableCheckbox: !x.categoryId,
              codePath: [...codePath, x.code],
              children: filterEmpty(x.children, [...codePath, x.code]),
            };
          }
          return {
            ...x,
            key: key, // 使用实际业务数据重新给 key 赋值
            value: key, // 使用实际业务数据重新给 value 赋值
            isLeaf: true,
            disableCheckbox: !x.categoryId,
            codePath: [...codePath, x.code],
            children: undefined,
          };
        });
        const tree = filterEmpty(result.data || [], []);
        this.setState({
          mainMenu: tree,
        });
        if ((window.document.body.clientHeight - 64 - 128 - 132) > (result.data.length * 42)) {
          this.setState({ mainHeight: window.document.body.clientHeight - 64 - 128 - 132 + 'px' });
        } else {
          this.setState({ mainHeight: result.data.length * 42 + (100 - 0) + 'px' });
        }
      } else {
        message.error(result.message);
      }
    });
  }

  resize() {
    if (this.state.mainMenu.length > 0) {
      if ((window.document.body.clientHeight - 64 - 128 - 132) > (this.state.mainMenu.length * 42)) {
        this.setState({ mainHeight: window.document.body.clientHeight - 64 - 128 - 132 + 'px' });
      } else {
        this.setState({ mainHeight: this.state.mainMenu.length * 42 + (100 - 0) + 'px' });
      }
    } else {
      this.setState({ mainHeight: window.document.body.clientHeight - 64 - 128 - 132 + 'px' });
    }
  }

  //获取购物车商品数量
  getCartCount() {
    const params = {
      userId: this.userData.id,
      name: '',
      category: [],
      active: '',
      s: 10,
      p: 1,
      channelCode: this.channelData.split('|')[1] || '',
    };
    getShoppingCarList(params).then((result) => {
      if (result.status && result.data) {
        this.setState({
          cartCount: result.data.count || null,
        });
      } else {
        if (!result.status) message.error(result.message);
      }
    });
  }

  //页面跳转
  goView(url) {
    hashHistory.push(url);
  }

  goList({ item, key, keyPath }) {
    const [code, index] = key.split('_');
    const { mainMenu } = this.state;
    this.setState({
      secondFlag: false,
      showFlag: false,
      maxKey: [index],
    });
    productActions.changeValue('maxKeyValue', mainMenu[index].value);
    productActions.changeValue('minKeyValue', '');
    productActions.changeValue('selectIndex', '0');
    this.goView('/mallHome');
    var newSearchData = {
      ...this.store.state.searchMallData,
      name: '',
      proBigType: mainMenu[index].value,
      proMiddleType: '',
      proDetailType: '',
      isHot: '',
      isNew: '',
      p: 1,
    };
    productActions.searchChange(newSearchData);
  }

  getMinKey({ item, key, keyPath }) {
    const [code, index] = key.split('_');
    const { mainMenu, maxKey, minMenu } = this.state;
    this.setState({
      secondFlag: false,
      showFlag: false,
    });
    productActions.changeValue('maxKeyValue', mainMenu[maxKey[0]].value);
    productActions.changeValue('minKeyValue', minMenu[index].value);
    productActions.changeValue('selectIndex', '0');
    this.goView('/mallHome');
  }

  mouseEnter(e) {
    const [code, index] = e.key.split('_');
    const firstMenu = { children: [], key: '', label: '全部', leaf: true, type: null, value: '' };
    var minMenu = [...this.state.mainMenu[index].children];
    if (minMenu.length > 0) {
      minMenu.unshift(firstMenu);
    }
    this.setState({
      secondFlag: true,
      maxKey: [index],
      selectKeys: [index],
      maxKeyValue: code,
      minMenu,
    });
  }

  mouseLeave(e) {
    this.setState({
      secondFlag: false,
      showFlag: false,
    });
  }

  menuShow() {
    this.setState({
      showFlag: !this.state.showFlag,
      maxKey: [],
    });
  }

  toggleHome() {
    let url = window.location.href;
    if (/dms-pc/.test(url)) {
      window.location.href = url.split('dms-pc')[0] + 'dms-pc/#/home';
    } else {
      window.location.href = '/#/home';
    }
  }

  //关键字改变
  keywordChange(e) {
    this.setState({
      keyword: e.target.value,
    });
  }

  toGetMall() {
    if (this.state.keyword) {
      var newSearch = {
        ...this.store.state.searchMallData,
        name: this.state.keyword,
        p: 1,
        s: 10,
        proBigType: '',
        proMiddleType: '',
        proDetailType: '',
        seriesCode: '',
        isHot: '1',
        isNew: '1',
      };
      productActions.searchChange(newSearch);
      hashHistory.push('/mallSearch');
    } else {
      message.info('请输入商品名称');
    }
  }

  render() {
    const { cartCount, secondFlag, showFlag, maxKey, minMenu, mainMenu, orderLength } = this.state;
    return <div>
      <Layout style={{ background: '#fff' }}>
        <Header className='home-header'>
          <div className="all-goods" style={{ cursor: 'pointer' }} onClick={this.menuShow}>
            <span>全部商品分类</span>
            {
              showFlag ?
                <i style={{ paddingLeft: '10px', fontSize: '16px' }} className="comIcon dmsArrowUp"></i>
                :
                <i style={{ paddingLeft: '10px', fontSize: '16px' }}
                   className="comIcon dmsArrowDown"> </i>
            }
          </div>
          {showFlag &&
          <div className='mall-menu' style={{ top: '128px' }} onMouseLeave={this.mouseLeave}>
            {
              secondFlag &&
              <div className="second-menu">
                <Menu mode="horizontal"
                      theme='second'
                      selectedKeys={[this.state.minKeyValue ? `${this.state.minKeyValue}` : '']}
                      onClick={this.getMinKey}>
                  {
                    minMenu.map((min, key) => {
                      return <Menu.Item key={`${min.code}_${key}`} className={key == 0 ? 'all' : ''}>
                        <span>{min.label}</span>
                      </Menu.Item>;
                    })
                  }
                </Menu>
              </div>
            }
            <Menu theme="mall"
                  mode="inline"
                  onClick={this.goList}>
              {
                mainMenu.map((main, key) => {
                  return <Menu.Item className={key == maxKey[0] && secondFlag ? 'menu-active' : ''}
                                    key={`${main.code}_${key}`} onMouseEnter={this.mouseEnter}>
                    <span>{main.label}</span>
                  </Menu.Item>;
                })
              }
            </Menu>
          </div>
          }
          {/*<div className="mall-logo">
           <a href="#" style={{cursor: 'default'}}>
           <h1>
           前海圆舟
           </h1>
           </a>
           </div>*/}
          <div className="mall-search">
						<Input placeholder='请输入商品名称' onChange={this.keywordChange.bind(this)} type="text"
                   onPressEnter={() => this.toGetMall()}
                   defaultValue={this.state.keyword} />
            <button onClick={this.toGetMall.bind(this)}>搜 索</button>
          </div>
          <div className='mall-cart' onClick={this.goView.bind(this, '/mallCart')}>
            <i className='comIcon dmsCart'></i>
            <span className='cart-word'>我的购物车</span>
            <Badge count={cartCount}>
              <span>&emsp;</span>
            </Badge>
          </div>
          {/*<div className="mall-go" onClick={this.toggleHome}>
           切换到卖家
           </div>*/}

          <div className="header-left" onClick={() => hashHistory.push('/mallHome')}>
            <i style={{ fontSize: '18px' }} className="dmsIcon dmsHome"></i>
            <span style={{ paddingLeft: '12px' }}>首页</span>
          </div>
          {/*<div className="header-right">*/}
            {/*<div className='mall-nav' onClick={() => this.userData.second ? hashHistory.push('/thingsOrder') : hashHistory.push('/order')}>
              <i className='nav-word comIcon orderIcon'></i>
              {
                orderLength > 99 ?
                  <span className='nav-dot-more'>99<sup>+</sup></span>
                  :
                  <span className='nav-dot'>{orderLength}</span>
              }
            </div>*/}
            {/*<div className='mall-nav'
             onClick={() => hashHistory.push('/mallCommon/userCenter/message')}>
             <i className='nav-word comIcon messageIcon'></i>
             {
             messageLength > 99 ?
             <span className='nav-dot-more'>99<sup>+</sup></span>
             :
             <span className='nav-dot'>{messageLength}</span>
             }
             </div>*/}
            {/*<div className='mall-nav'
                 onClick={() => hashHistory.push('/mallCommon/userCenter/userInfo')}>
              <sapn className='nav-word comIcon userIcon'></sapn>
            </div>*/}
          {/*</div>*/}
        </Header>
      </Layout>
      <Content style={{ minHeight: this.state.mainHeight, background: '#fff' }}>
        {this.props.children}
      </Content>
    </div>;
  }
}
;
export default MallCommon;



// WEBPACK FOOTER //
// ./src/mall/mallDetail/index.js